"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Heading = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = __importDefault(require("@emotion/styled"));
const styled_system_1 = require("styled-system");
const constants_1 = require("../constants");
const utils_1 = require("../utils");
const styled_system_2 = require("../utils/styled-system");
const fontSize = (size, { mobile = true }) => {
    const toFontSize = (headingSize) => {
        return getFontSize(headingSize, { mobile });
    };
    return (0, styled_system_2.fontSize)({
        fontSize: Array.isArray(size) ? size.map(toFontSize) : toFontSize(size),
    });
};
const getFontSize = (size, { mobile }) => {
    return mobile && size < 6
        ? constants_1.theme.font.size[(size + 1)]
        : constants_1.theme.font.size[size];
};
/**
 * NOTE:
 * The level is not the same as the size, even though the level decides the size by default.
 * The heading level can be used for SEO purposes, while the size is purely cosmetic.
 *
 * It is recommended to have exactly one <h1> level element per page.
 */
const Heading = (props) => {
    const size = props.size ?? props.level;
    const HeadingElement = (0, styled_1.default)(`h${props.level || 1}`)({
        alignItems: 'flex-start',
        color: props.color,
        display: props.display ?? (props.setDefaultDisplay !== false ? 'flex' : undefined),
        flexDirection: 'column',
        ...(0, styled_system_1.flexbox)(props),
        ...fontSize(size, { mobile: true }),
        lineHeight: 1.3,
        maxWidth: props.wide ? 840 : 600,
        marginBottom: 20,
        marginTop: 0,
        ...(props.level === 6
            ? {
                fontSize: 13,
                fontWeight: constants_1.theme.font.weight.bold,
                letterSpacing: '0.03rem',
                marginBottom: 8,
                textTransform: 'uppercase',
            }
            : {}),
        minWidth: props.minWidth,
        ...(0, styled_system_2.space)(props),
        ...(0, styled_system_2.typography)(props),
        ...(0, styled_system_2.zIndex)(props),
        userSelect: props.noSelect ? 'none' : undefined,
        [(0, utils_1.mediaBreakpointGte)('md')]: {
            ...fontSize(size, { mobile: false }),
        },
    });
    return ((0, jsx_runtime_1.jsx)(HeadingElement, { className: props.className, children: props.children }));
};
exports.Heading = Heading;
